import { Links } from "./vehicleSearch.type";

const getPageLinkType = (type: string, links: Links[]): string => {
  const pageType = links.filter((current) => current?.rel === type);
  return pageType[0]?.href;
};

export default getPageLinkType;
